import {
  validateErrors,
  required,
  maxLength,
  email,
} from '../validators';


const validate = (values) => {
  const validators = {
    email: [email, maxLength(200), required],
  };
  return validateErrors(values, validators);
};

export default validate;
